import styled from 'styled-components';

export const LabelContainer = styled.div`
  margin: 0 0 8px 0;
  display: block;
  .smart-label, .smart {
    margin-right: 10px;
    position: absolute;
    z-index: 10;
    padding-left: 11px;
    padding-top: 0px;
  }
  .default{
    color: ${({ theme }) => (theme.colors.panel.main.foreground)};
  }
  .error {
    color: ${({ theme }) => (theme.colors.errorRed01)};
  }
  .success {
    color: ${({ theme }) => (theme.colors.acceptedGreen)};
  }
  .disabled {
    color: ${({ theme }) => (theme.colors.panel.main.foreground)};
  }
  &&&.inline {
    display: inline-block;
    margin: 0 8px 0 0;
  }
  &&&.hidden {
    display: none;
  }
`;

export const Label = styled.label`
  white-space: nowrap;
`;
